module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-woman-40@2x_7cb1c9a25417625dde4b02f13081be0e.jpg";